// 国际化的单复数规则
// 引入intl-pluralrules是为了兼容低版本浏览器
import 'intl-pluralrules';
// 翻译
const DEFAULT_MAP = ['zero', 'one', 'two', 'few', 'many', 'other']; // 默认翻译规则
// 所有语种翻译规则
const PLURALS_MAP = {
  arsa: { local: 'ar-SA', rule: ['zero', 'one', 'two', 'few', 'many', 'other'] },
  dede: { local: 'de-DE', rule: ['one', 'other'] },
  enmy: { local: 'en-MY', rule: ['other'] },
  enus: { local: 'en-US', rule: ['one', 'other'] },
  eses: { local: 'es-ES', rule: ['one', 'other'] },
  esmx: { local: 'es-MX', rule: ['one', 'other'] },
  fair: { local: 'fa-IR', rule: ['one', 'other'] },
  frfr: { local: 'fr-FR', rule: ['one', 'other'] },
  inid: { local: 'in-ID', rule: ['other'] },
  itit: { local: 'it-IT', rule: ['one', 'other'] },
  jajp: { local: 'ja-JP', rule: ['other'] },
  mymm: { local: 'my-MM', rule: ['other'] },
  plPL: { local: 'pl-PL', rule: ['one', 'few', 'many', 'other'] },
  ptbr: { local: 'pt-BR', rule: ['one', 'other'] },
  ruru: { local: 'ru-RU', rule: ['one', 'few', 'many', 'other'] },
  thth: { local: 'th-TH', rule: ['other'] },
  trtr: { local: 'tr-TR', rule: ['one', 'other'] },
  vivn: { local: 'vi-VN', rule: ['other'] },
  zhcn: { local: 'zh-CN', rule: ['other'] },
  // 以下语言未使用
  am: { local: 'am', rule: ['one', 'other'] },
  as: { local: 'as', rule: ['one', 'other'] },
  az: { local: 'az', rule: ['one', 'other'] },
  be: { local: 'be', rule: ['one', 'few', 'many', 'other'] },
  bg: { local: 'bg', rule: ['one', 'other'] },
  bn: { local: 'bn', rule: ['one', 'other'] },
  bo: { local: 'bo', rule: ['other'] },
  bs: { local: 'bs', rule: ['one', 'few', 'other'] },
  ca: { local: 'ca', rule: ['one', 'other'] },
  cs: { local: 'cs', rule: ['one', 'few', 'many', 'other'] },
  da: { local: 'bs', rule: ['one', 'few', 'many', 'other'] },
  el: { local: 'el', rule: ['one', 'other'] },
  'en-gb': { local: 'en-GB', rule: ['one', 'other'] },
  'en-us': { local: 'en-US', rule: ['one', 'other'] },
  'en-cn': { local: 'en-US', rule: ['one', 'other'] },
  'es-us': { local: 'es-ES', rule: ['one', 'other'] },
  et: { local: 'et', rule: ['one', 'other'] },
  eu: { local: 'eu', rule: ['one', 'other'] },
  fa: { local: 'fa', rule: ['one', 'other'] },
  fi: { local: 'fi', rule: ['one', 'other'] },
  gl: { local: 'gl', rule: ['one', 'other'] },
  gu: { local: 'gu', rule: ['one', 'other'] },
  hi: { local: 'hi', rule: ['one', 'other'] },
  hr: { local: 'es', rule: ['one', 'few', 'other'] },
  hu: { local: 'hu', rule: ['one', 'other'] },
  in: { local: 'in', rule: ['other'] },
  id: { local: 'in', rule: ['other'] },
  it: { local: 'it', rule: ['one', 'other'] },
  iw: { local: 'iw', rule: ['one', 'two', 'many', 'other'] },
  he: { local: 'iw', rule: ['one', 'two', 'many', 'other'] },
  jv: { local: 'jv', rule: ['other'] },
  ka: { local: 'ka', rule: ['one', 'other'] },
  kk: { local: 'kk', rule: ['one', 'other'] },
  km: { local: 'km', rule: ['other'] },
  kn: { local: 'kn', rule: ['one', 'other'] },
  ko: { local: 'ko', rule: ['other'] },
  lo: { local: 'lo', rule: ['other'] },
  lt: { local: 'lt', rule: ['other'] },
  lv: { local: 'lv', rule: ['zero', 'one', 'other'] },
  mai: { local: 'mai', rule: ['zero', 'one', 'two', 'few', 'many', 'other'] },
  mi: { local: 'mi', rule: ['zero', 'one', 'two', 'few', 'many', 'other'] },
  mk: { local: 'mk', rule: ['one', 'other'] },
  ml: { local: 'ml', rule: ['one', 'other'] },
  mn: { local: 'mn', rule: ['one', 'other'] },
  mr: { local: 'mr', rule: ['one', 'other'] },
  ms: { local: 'ms', rule: ['other'] },
  'my-zz': { local: 'my-MM', rule: ['other'] },
  nb: { local: 'nb', rule: ['one', 'other'] },
  ne: { local: 'ne', rule: ['one', 'other'] },
  nl: { local: 'nl', rule: ['one', 'other'] },
  or: { local: 'or', rule: ['one', 'other'] },
  pa: { local: 'pa', rule: ['one', 'other'] },
  'pt-bt': { local: 'pt-PT', rule: ['one', 'other'] },
  ro: { local: 'ro', rule: ['one', 'few', 'other'] },
  si: { local: 'si', rule: ['one', 'other'] },
  sk: { local: 'sk', rule: ['one', 'few', 'many', 'other'] },
  sl: { local: 'sl', rule: ['one', 'two', 'few', 'other'] },
  'sr-rs': { local: 'sr-RS', rule: ['one', 'few', 'other'] },
  sv: { local: 'sv', rule: ['one', 'other'] },
  sw: { local: 'sw', rule: ['one', 'other'] },
  ta: { local: 'ta', rule: ['one', 'other'] },
  te: { local: 'te', rule: ['one', 'other'] },
  th: { local: 'th', rule: ['other'] },
  tl: { local: 'tl', rule: ['one', 'other'] },
  fil: { local: 'tl', rule: ['one', 'other'] },
  ug: { local: 'ug', rule: ['one', 'other'] },
  uk: { local: 'uk', rule: ['one', 'few', 'many', 'other'] },
  ur: { local: 'ur', rule: ['one', 'other'] },
  uz: { local: 'uz', rule: ['one', 'other'] },
  'zh-hk': { local: 'zh-HK', rule: ['other'] },
  'zh-tw': { local: 'zh-TW', rule: ['other'] },
  zz: { local: 'en-US', rule: ['one', 'other'] },
};

function getRuleMap() {
  function buildPluralRule(lang, choice, choicesLength) {
    const PLURAL_LIST = PLURALS_MAP[lang];

    const pr = new Intl.PluralRules(PLURAL_LIST.local);
    // 核心部分就是通过浏览器的国际化，根据对应的规则匹配到对应的翻译标识，如‘one’，‘other’等
    const rule = pr.select(choice);
    let res = PLURAL_LIST.rule.indexOf(rule);
    if (res < 0 || PLURAL_LIST.rule.length !== choicesLength) {
      res = DEFAULT_MAP.indexOf(rule);
    }
    if (res < 0 || res > choicesLength - 1) {
      res = 0;
    }
    // 根据标识返回索引值
    return res;
  }
  /**
   * 对单个语种生成支撑单复数选择的钩子方法
   */
  function buildChoiceFunc(lang) {
    return (choice, choicesLength) => {
      return buildPluralRule(lang, choice, choicesLength);
    };
  }
  const langs = Object.keys(PLURALS_MAP);
  const rules = {};
  langs.forEach(lang => {
    rules[lang] = buildChoiceFunc(lang);
  });
  // 最终返回规则对象
  return rules;
}
export const ruleMap = getRuleMap();
